/** Two half-turns form a complete visual loop. The frame never snaps upright. */
export function treasuryHourglassMotion(elapsedMs: number, reduced = false) {
  const time = reduced ? 2400 : Math.max(0, elapsedMs) % 13600;
  const turn = Math.floor(time / 6800), phase = time % 6800;
  const flip = Math.max(0, (phase - 6000) / 800);
  return {
    phase,
    fill: Math.min(phase / 6000, 1),
    rotation: (turn + (1 - Math.cos(Math.PI * flip)) / 2) * Math.PI,
    sandRotation: turn * Math.PI,
  };
}
